import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom/client";
import "./tailwind.css";
import "./index.scss";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { createStore } from "redux";
import allReducer from "./reducers";
import { Provider } from "react-redux";
import Store from "./Store";

ReactDOM.createRoot(
  document.getElementById("root")
).render(
  <Provider store={Store}>
    <App />
  </Provider>
);

serviceWorker.unregister();
